module.exports = __webpack_public_path__ + "static/enjoy-24e22bbf4241229bd859dfb0272ce5b9.png";